import React, { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { setAuthorization } from "../helpers/api_helper";
import { useDispatch } from "react-redux";
import { useProfile } from "../Components/Hooks/UserHooks";
import { logoutUser } from "../slices/auth/login/thunk";
import { authProtectedRoutes } from "./allRoutes";

export const AuthProtected = ({ children }) => {
  const dispatch = useDispatch();
  const { userProfile, loading, token } = useProfile();
  const location = useLocation();
  
  useEffect(() => {
    if (userProfile && !loading && token) {
      setAuthorization(token);
    } else if (!userProfile && loading && !token) {
      dispatch(logoutUser());
    }
  }, [token, userProfile, loading, dispatch]);

  if (!userProfile && loading && !token) {
    return <Navigate to="/login" replace />;
  }

  // Proteção por role
  const currentRoute = authProtectedRoutes.find(route => {
    if (route.path.includes(":")) {
      const basePath = route.path.split("/:")[0];
      return location.pathname.startsWith(basePath);
    }
    return route.path === location.pathname;
  });

  if (currentRoute?.roles && !currentRoute.roles.includes(userProfile.tipo)) {
    return <Navigate to="/starter" replace />;
  }

  return <>{children}</>;
};
